export const businessCentralOnPremConfiguration = {
  BusinessCentralOnPrem: `Business Central (Instalación Local)`,
  "Connect to your Business Central api.": `Conéctate a tu API de Business Central`,
  business_central_on_prem_configurations: `Business Central (Instalación Local) configurations`,
  businesscentral_onprem_output_connector: {
    userName: `Nombre de usuario`,
    password: `Contraseña`,
    baseUrl: `URL base`,
    environment: `Entorno`,
  },
};
